import { trackFilteredDealerLocation } from './dealer/dealer.tracking';
import { trackFilteredNetwork } from './network/network.tracking';

export const LEVEL_TRACKING = {
  trackFilteredDealerLocation,
  trackFilteredNetwork,
};
